<template>
  <div class="contact-form-subsection">
    <div class="form-container">
      <div class="form-header">
        <h2 class="form-title">Envoyez-nous un message</h2>
        <p class="form-description">
          Remplissez le formulaire ci-dessous et nous vous répondrons dans les plus brefs délais.
        </p>
      </div>

      <form class="contact-form" @submit.prevent="handleSubmit">
        <div class="form-row">
          <div class="form-group">
            <label class="form-label" for="firstName">Prénom *</label>
            <input
              class="form-input"
              type="text"
              id="firstName"
              placeholder="Votre prénom"
              required
            />
          </div>

          <div class="form-group">
            <label class="form-label" for="lastName">Nom *</label>
            <input
              class="form-input"
              type="text"
              id="lastName"
              placeholder="Votre nom"
              required
            />
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="email">Email *</label>
          <input
            class="form-input"
            type="email"
            id="email"
            placeholder="votre.email@exemple.com"
            required
          />
        </div>

        <div class="form-group">
          <label class="form-label" for="phone">Téléphone</label>
          <input
            class="form-input"
            type="tel"
            id="phone"
            placeholder="+33 6 12 34 56 78"
          />
        </div>

        <div class="form-group">
          <label class="form-label" for="subject">Sujet *</label>
          <select class="form-select" id="subject" required>
            <option value="">Sélectionnez un sujet</option>
            <option value="demo">Demande de démo</option>
            <option value="support">Support technique</option>
            <option value="sales">Questions commerciales</option>
            <option value="partnership">Partenariat</option>
            <option value="other">Autre</option>
          </select>
        </div>

        <div class="form-group">
          <label class="form-label" for="message">Message *</label>
          <textarea
            class="form-textarea"
            id="message"
            rows="6"
            placeholder="Décrivez votre demande..."
            required
          ></textarea>
        </div>

        <button class="submit-button" type="submit">
          <span class="button-text">Envoyer le message</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ContactFormSubsection",
  methods: {
    handleSubmit() {
      alert("Formulaire soumis ! (Démo uniquement)");
    }
  }
});
</script>

<style>
.contact-form-subsection {
  align-items: center;
  align-self: stretch;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  padding: 80px 30px;
  position: relative;
  width: 100%;
}

.contact-form-subsection .form-container {
  align-items: flex-start;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 800px;
  padding: 48px;
  width: 100%;
}

.contact-form-subsection .form-header {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-form-subsection .form-title {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
}

.contact-form-subsection .form-description {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
}

.contact-form-subsection .contact-form {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.contact-form-subsection .form-row {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
}

.contact-form-subsection .form-group {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.contact-form-subsection .form-row .form-group {
  flex: 1;
  min-width: 250px;
}

.contact-form-subsection .form-label {
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
}

.contact-form-subsection .form-input,
.contact-form-subsection .form-select,
.contact-form-subsection .form-textarea {
  align-self: stretch;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  box-sizing: border-box;
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  padding: 12px 16px;
  transition: border-color 0.2s ease;
  width: 100%;
}

.contact-form-subsection .form-input:focus,
.contact-form-subsection .form-select:focus,
.contact-form-subsection .form-textarea:focus {
  border-color: #084734;
  outline: none;
}

.contact-form-subsection .form-input::placeholder,
.contact-form-subsection .form-textarea::placeholder {
  color: #9ca3af;
}

.contact-form-subsection .form-textarea {
  resize: vertical;
}

.contact-form-subsection .submit-button {
  all: unset;
  align-self: stretch;
  background-color: #084734;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
  height: 48px;
  overflow: hidden;
  padding: 12px 32px;
  position: relative;
  text-align: center;
  transition: all 0.2s ease;
}

.contact-form-subsection .submit-button:hover {
  background-color: #0a5a42;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
}

.contact-form-subsection .button-text {
  color: #ffffff;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
}

@media (max-width: 768px) {
  .contact-form-subsection .form-container {
    padding: 32px 24px;
  }
}
</style>
